export default function PRReportPackageGeneratedPackagesController(
  $q,
  $rootScope,
  $scope,
  loaderService,
  reportsDataService,
) {
  const vm = this;

  vm.isExpanded = true;
  vm.hasData = false;

  vm.handleExpandGeneratedPackages = _handleExpandGeneratedPackages;
  vm.reportPackageId = vm.reportPackage.reportPackageConfiguration.reportPackageId;

  _activate();

  _initEventListeners();

  /** ********************************************
   * Event Handlers
   */

  function _handleExpandGeneratedPackages() {
    vm.isExpanded = !vm.isExpanded;
  }

  /** ********************************************
   * Private Functions
   */

  function _activate() {}

  function _initEventListeners() {
    $scope.$on('reports.generatedPackageDeleted', (event, opt) => {
      if (opt.reportPackageId === vm.reportPackageId) {
        _refreshGeneratedPackages();
      }
    });
    $scope.$on('generatePackageQueued', (event, opt) => {
      if (opt.reportPackageId === vm.reportPackageId) {
        _refreshGeneratedPackages();
      }
    });
  }

  function _refreshGeneratedPackages() {
    const dfdRefresh = $q.defer();

    reportsDataService.getGeneratedPackageExecutions(vm.reportPackageId).then(response => {
      vm.reportPackage.reportPackageExecutions = [];
      if (response.data.recordCount > 0) {
        angular.extend(vm.reportPackage.reportPackageExecutions, response.data.result);
      }

      if (response.data.recordCount !== vm.reportPackage.numberOfPackageExecutions) {
        vm.reportPackage.numberOfPackageExecutions = response.data.recordCount;

        if (vm.reportPackage.numberOfPackageExecutions === 0) {
          vm.isExpanded = false;
        }
      }

      dfdRefresh.resolve();
    });
    return dfdRefresh.promise;
  }
}

PRReportPackageGeneratedPackagesController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'loaderService',
  'reportsDataService',
];
